












































import { Component, Vue } from 'vue-property-decorator'
import SuporteTabelaContratos from '@/components/RemuneracaoMedica/suporte/components/SuporteTabelaContratos.vue'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import RemuneracaoSuporteContratosRightNavBar from '@/components/RemuneracaoMedica/NavBar/RemuneracaoSuporteContratosRightNavBar.vue'

@Component({
  components: {
    SuporteTabelaContratos,
    RemuneracaoSuporteContratosRightNavBar
  }
})

export default class ViewSuporteContratos extends Vue {
  tabs: string = ''
  tab: string = 'principal'
  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get drawer() {
    return this.getBackofficeContratosStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeContratosStore.setFilterDrawer(value)
  }

  set loadingTable(value: boolean) {
    this.getBackofficeContratosStore.setLoadingTabelaContratos(value)
  }

  get pagination() {
    return this.tab === 'principal' ? this.getBackofficeContratosStore.paginationRemuneracao : this.getBackofficeContratosStore.pagination
  }

  get getPagina() {
    return this.pagination.page
  }

  set getPagina(value: number) {
    this.tab === 'principal' ? this.getBackofficeContratosStore.setPaginaRemuneracao(value) : this.getBackofficeContratosStore.setPagina(value)
  }

  get remuneracaoLength() {
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults() {
    this.loadingTable = true
    this.tab === 'principal' ? await this.getBackofficeContratosStore.getContratosVisaoGestorBaseRemuneracao(this.pagination) : await this.getBackofficeContratosStore.getContratosVisaoGestor(this.pagination)
    this.loadingTable = false
  }

  tabChange() {
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async init() {
    this.loadingTable = true
    await this.getBackofficeContratosStore.getContratosVisaoGestorBaseRemuneracao(this.pagination)
    await this.getBackofficeContratosStore.getContratosVisaoGestor(this.pagination)
    await this.getBackofficeContratosStore.getGrupoHospitalOptions()
    this.loadingTable = false
  }

  async created() {
    await this.init();
  }
}
